import fp from 'lodash/fp';

import { getFilters } from '../../webcommon/header/filterheader/selectors';

export const getDisplayedProductClasses = state => fp.get('value[0]')(
    fp.first(
        getFilters(state, 'StaticDataIsda')
    )
);

export const getRoot = state => state.staticDataIsda;

export const getCurrentServerFilters = state => getRoot(state).currentServerFilters;

export const getDefaultFilters = state => getRoot(state).defaultFilters;

export const getFilterDefinitions = state => getRoot(state).filterDefinitions;

export const getInitialised = state => getRoot(state).initialised;

export const getProductClasses = state => getRoot(state).productClassData;

export const getProductClassData = state => fp.get(
    getDisplayedProductClasses(state)
)(getProductClasses(state));

export const getFetchingProductClasses = state => getRoot(state).fetchingProductClassData;

export const getFetchingProductClassesErrors = state => getRoot(state).fetchingProductClassError;
